import { connect } from 'react-redux';
import { State } from 'store/types';
import { fetchBanners } from 'shared/store/product/action';
import Switch from './Switch';

const mapStateToProps = (state: State) => {
  const { remoteConfig, productPage } = state;
  return {
    bannersEnabled: !!remoteConfig.switches.pdPageBanners,
    hasUniversalBanners: !!remoteConfig.switches.universalBanners,
    banners: productPage.banners,
    isPaginationEnabled: remoteConfig.switches.isPaginationEnabled,
    remainingInventoryIds: productPage.remaining_inventories_ids,
    queryParamsObject: productPage.queryParamsObject,
  };
};

const mapDispatchToProps = {
  fetchBanners,
};

export default connect(mapStateToProps, mapDispatchToProps)(Switch);
